<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">{{ rental_item.category.name }} (ID: {{ $route.params.id }})</h1>
        <div class="conditions">
          <span
            v-for="item of 5"
            :key="item"
            class="conditions__item"
            :class="{'conditions__item--checked': item <= rental_item.condition}"
          />
        </div>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card">
          <button
            class="info-cards__control"
            @click="onShowModal"
          >
            <img src="@/assets/img/edit-table-icon.svg" alt="">
          </button>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Brand:</span> <span>{{ rental_item.brand.name }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item">
              <span>Color:</span><span>{{ rental_item.color.name }}</span>
            </div>
            <div class="info-cards__row-item">
              <span>Size:</span><span>{{ rental_item.size.name }}</span>
            </div>
          </div>
        </div>
      </div>
<!--      <app-cells><h2 class="title">Rentals</h2></app-cells>-->
<!--      <v-client-table-->
<!--        :data="table.items"-->
<!--        :columns="table.columns"-->
<!--        :options="table.options"-->
<!--        class="table-default"-->
<!--        :class="{ 'table-default&#45;&#45;loading': table_preloader }"-->
<!--      >-->
<!--        <template #h__id><div class="table-default__left">ID</div></template>-->
<!--        <template #id="{ row }">-->
<!--          <div class="table-default__left">-->
<!--            <router-link :to="{name: 'rentals-detail', params: {id: row.id }}" class="table-default__link-border">-->
<!--              Rental - {{ row.id }}-->
<!--            </router-link>-->
<!--          </div>-->
<!--        </template>-->
<!--        <template #rental_start="{ row }">{{ dateFormat(row.rental_start) }}</template>-->
<!--        <template #rental_end="{ row }">{{ dateFormat(row.rental_end) }}</template>-->
<!--        <template #returned="{ row }">-->
<!--          <span-->
<!--            class="status-tag"-->
<!--            :style="{ 'backgroundColor': row.returned ? '#77b017' : '#e85c20' }"-->
<!--          >-->
<!--            {{ row.returned ? 'Yes' : 'No' }}-->
<!--          </span>-->
<!--        </template>-->
<!--        <template #no_damages="{ row }">-->
<!--          <span-->
<!--            class="status-tag"-->
<!--            :style="{ 'backgroundColor': row.no_damages ? '#77b017' : '#f0c427' }"-->
<!--          >-->
<!--            {{ row.no_damages ? 'Yes' : 'No' }}-->
<!--          </span>-->
<!--        </template>-->
<!--        <template #status_after="{ row }">{{ row.status_after?.name || '-' }}</template>-->
<!--      </v-client-table>-->
<!--      <app-cells position="between">-->
<!--        <div>-->
<!--          <paginate-->
<!--            :clickHandler="onClickPagination"-->
<!--            v-if="pagination.pages > 1"-->
<!--            v-model="pagination.page"-->
<!--            :page-count="pagination.pages"-->
<!--            :prev-text="'<'"-->
<!--            :next-text="'>'"-->
<!--            :container-class="'pagination'"-->
<!--            :page-class="'pagination__item'"-->
<!--            :page-link-class="'pagination__link'"-->
<!--            :prev-class="'pagination__item pagination__item&#45;&#45;prev'"-->
<!--            :next-class="'pagination__item pagination__item&#45;&#45;next'"-->
<!--            :next-link-class="'pagination__link pagination__link&#45;&#45;next'"-->
<!--            :prev-link-class="'pagination__link pagination__link&#45;&#45;prev'"-->
<!--          />-->
<!--        </div>-->
<!--        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />-->
<!--      </app-cells>-->
    </template>
    <modal
      name="rental-form"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('rental-form')" class="popup__close" type="button"></button>
        <div class="popup__title">Edit item</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="Number" required label-for="form_id">
              <app-input
                v-model.number="form.number"
                id="form_id"
                type="number"
                min="0"
                placeholder="Type"
                name="form_id"
                :error="$v.form.number.$error"
              />
              <template #error>
                <div v-if="$v.form.number.$dirty && !$v.form.number.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Category" required>
              <app-select
                v-model="form.category"
                :options="category_options"
                :reduce="item => item.id"
                :clearable="false"
                placeholder="Choose"
                :error="$v.form.category.$error"
              />
              <template #error>
                <div v-if="$v.form.category.$dirty && !$v.form.category.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Brand" required>
              <app-select
                v-model="form.brand"
                :options="brand_options"
                :reduce="item => item.id"
                :clearable="false"
                placeholder="Choose"
                :error="$v.form.brand.$error"
              />
              <template #error>
                <div v-if="$v.form.brand.$dirty && !$v.form.brand.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Color" required>
              <app-select
                v-model="form.color"
                :options="color_options"
                :reduce="item => item.id"
                :clearable="false"
                placeholder="Choose"
                :error="$v.form.color.$error"
              />
              <template #error>
                <div v-if="$v.form.color.$dirty && !$v.form.color.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Size" required>
              <app-select
                v-model="form.size"
                :options="size_options"
                :reduce="item => item.id"
                :clearable="false"
                placeholder="Choose"
                :error="$v.form.size.$error"
              />
              <template #error>
                <div v-if="$v.form.size.$dirty && !$v.form.size.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Condition" required>
              <div class="conditions conditions--form">
                <label
                  v-for="item of 5"
                  :key="item"
                  class="conditions__item"
                  :class="{'conditions__item--checked': item <= form.condition}"
                >
                  <input v-model="form.condition" :value="item" type="radio">
                </label>
              </div>
              <template #error>
                <div v-if="$v.form.condition.$dirty && !$v.form.condition.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form.$error" type="submit" ref="submit">Save</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getEquipmentStorageBrand,
  getEquipmentStorageCategory,
  getEquipmentStorageColor,
  getEquipmentStorageItem,
  getEquipmentStorageItemRentals,
  getEquipmentStorageSize,
  patchEquipmentStorageItem,
} from '@/http'
import { format, parse } from 'date-fns'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'RentalItemsDetail',
  data() {
    return {
      is_loaded: false,
      table_preloader: true,
      rental_item: {},
      table: {
        items: [],
        columns: ['id', 'status.name', 'rental_start', 'rental_end', 'returned', 'no_damages', 'status_after'],
        options: {
          headings: {
            'id': 'ID',
            'status.name': 'Status',
            'rental_start': 'Start',
            'rental_end': 'End',
            'returned': 'Returned',
            'no_damages': 'No damages',
            'status_after': 'Status',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      form: {},
      category_options: [],
      brand_options: [],
      color_options: [],
      size_options: [],
    }
  },
  validations: {
    form: {
      category: { required },
      brand: { required },
      color: { required },
      size: { required },
      number: { required },
      condition: { required },
    }
  },
  created() {
    // this.fetchItems()
    this.fetchData()
    getEquipmentStorageCategory().then(response => { this.category_options = response.data })
    getEquipmentStorageBrand().then(response => { this.brand_options = response.data })
    getEquipmentStorageColor().then(response => { this.color_options = response.data })
    getEquipmentStorageSize().then(response => { this.size_options = response.data })
  },
  methods: {
    fetchData() {
      getEquipmentStorageItem(this.$route.params.id)
        .then(response => {
          this.rental_item = response.data
          document.title = `${this.rental_item.category.name} (ID: ${ this.$route.params.id }) | Altezza Board`
          this.is_loaded = true
        })
    },
    fetchItems() {
      this.table_preloader = true
      getEquipmentStorageItemRentals(this.$route.params.id, { page: this.pagination.page, page_size: 20 })
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.table_preloader = false
        })
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      patchEquipmentStorageItem(this.$route.params.id, this.form)
        .then(() => {
          this.fetchData()
          this.$notify({
            type: 'success',
            title: 'Item saved',
          })
          this.$modal.hide('rental-form')
        })
        .catch(() => { this.$refs.submit.preload = false })
    },
    onShowModal() {
      this.form = {
        category: this.rental_item.category.id,
        brand: this.rental_item.brand.id,
        color: this.rental_item.color.id,
        size: this.rental_item.size.id,
        number: this.rental_item.number,
        condition: this.rental_item.condition,
      }
      this.$v.form.$reset()
      this.$modal.show('rental-form')
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : ''
    },
  }
}
</script>
